import { apiRequest } from "./api";
import type { UsZipLocationResponseDto } from "../types/types";

export const locationApi = {
  usZipDetails(zip: string): Promise<UsZipLocationResponseDto> {
    const params = new URLSearchParams({
      zip: zip.trim().slice(0, 5),
    });
    return apiRequest<UsZipLocationResponseDto>(`/api/location/us-zip-details?${params.toString()}`, {
      method: "GET",
    });
  },
};
